import React from 'react';
import PropTypes from 'prop-types';
import Photo from './Photo';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Bestof from './Bestof';

const Gallery = (props) => {
    if (!props.gallery) {
        return (
            <Container fluid={true}>
                <Row>
                    <Col>
                        <h1 className="mb-4">3D Photography <br /><small>by Aaron Zygmunt</small></h1>
                        <h3 className="mb-4">A gallery of my 3D photos.</h3>
                        <p className="lead">Check out the <strong>Collections</strong> menu for more photos.<br />
                            Use the <strong>Options</strong> menu to change the 3D viewing mode.</p>
                        <p className="lead">Here are a few to get started</p>
                        <Bestof
                            paths={props.paths}
                            options={props.options}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
    return (
        <Container fluid={true}>
            <Row>
                <Col>
                    <h2>{props.currentCategory.name}</h2>
                </Col>
            </Row>
            <Row className="row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
                {props.gallery.map(photo => (
                    <Col key={photo.id}>
                        <Photo
                            photo={photo}
                            onClick={props.onClick}
                            paths={props.paths}
                            options={props.options}
                        />
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

Gallery.propTypes = {
    gallery: PropTypes.array,
    photo: PropTypes.object,
    paths: PropTypes.object,
    currentCategory: PropTypes.object,
    onClick: PropTypes.func,
    options: PropTypes.object
};

export default Gallery;
